import React, { memo } from 'react';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Text, View } from '../Base';
import { DISASTER_RECOVERY } from '../../constants/strings';
import palette from '../styles/palette';
import { WarningIcon } from '../icons';

const useStyles = makeStyles(({ typography }) => ({
  button: {
    color: palette.typography.white.solid,

    '&:hover': {
      background: 'transparent',
    },
  },
  text: {
    color: palette.typography.white.solid,
    fontSize: typography.pxToRem(12),
    fontWeight: 400,
  },
  icon: {
    maxWidth: typography.pxToRem(15),
    maxHeight: typography.pxToRem(16),

    '& svg': {
      width: typography.pxToRem(15),
      height: typography.pxToRem(16),
      fill: palette.typography.white.solid,
    },
  },
}));

const DisasterRecovery = ({ onDisasterRecovery }) => {
  const classes = useStyles();

  return (
    <Button
      disableRipple
      onClick={onDisasterRecovery}
      className={classes.button}
      endIcon={
        <View className={classes.icon}>
          <WarningIcon />
        </View>
      }
      data-testid="disaster-recovery"
    >
      <Text className={classes.text}>{DISASTER_RECOVERY}</Text>
    </Button>
  );
};

export default memo(DisasterRecovery);
